import { createModel } from '@rematch/core';
import { contentLanguagesService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';

export type ContentLanguages = Record<string, string>;
export type ContentLanguageState = ContentLanguages | null; // null is used as a isFetching flag

const defaultState = null as ContentLanguageState;

export const contentLanguages = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        saveContentLanguages: (_state, payload: ContentLanguages = {}): ContentLanguageState =>
            payload,
    },
    effects: dispatch => ({
        async fetchContentLanguages(): Promise<void> {
            const contentLanguagesData = await contentLanguagesService.fetchContentLanguages();
            if (contentLanguagesData) {
                const availableContentLanguages = {};
                contentLanguagesData.forEach(language => {
                    availableContentLanguages[language.name] = language.code;
                });

                dispatch.contentLanguages.saveContentLanguages(availableContentLanguages);
            }
        },
    }),
});
